<template>
  <div class="table-container">
    <el-table :data="records" border >
      <el-table-column prop="sysPropertiesInfoId" label="ID" width="80" align="center">
      </el-table-column>
      <el-table-column prop="oldLineName" label="老系统线路名称" align="center">
      </el-table-column>
      <el-table-column prop="newDestinationName" label="新系统出发-目的地" align="center">
      </el-table-column>
      <el-table-column prop="jumpTime" label="跳转日期" align="center">
      </el-table-column>
      <el-table-column label="编辑" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            icon="el-icon-delete"
            @click="deleteClick(scope.row)"
            class="delete"
            >删除</el-button>
        </template>
        
      </el-table-column>
    </el-table>
    <el-pagination class="pagination-item" background layout="prev, pager, next"
    @current-change="currentChange"  @prev-click="prevClick" @next-click="nextClick" :total="total"/>
  </div>
</template>

<script>
import LineEdit from "./line-edit";
export default {
  components: {
    LineEdit,
  },
  props:{
      total:{
          type: Number,
          default: 0
      },
      records:{
          type: Array,
          default:  () => []
      },
  },
  data() {
    return {
      records:[],
      sysPropertiesInfoId:'',
      dialogFormVisible: false,
      formLabelWidth: "120px",
    };
  },
  methods: {
    open2() {
      this.$message({
        message: "已保存成功！",
        type: "success",
      });
    },
    currentChange(e){
         this.$emit('current',e)
    },
    prevClick(e){
         this.$emit('current',e)
    },
    nextClick(e){
        this.$emit('current',e)
    },


    // 删除线路
    deleteClick(obj) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
      .then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.$emit("delete",obj.sysPropertiesInfoId);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
  },
};

</script>

<style lang="scss" scoped>
.table-container{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .pagination-item{
        margin-top: 20px;
    }
}
.delete {
  color: #e47470;
  margin-left: 10px;
}
</style>